import { useContext } from "react";
import hash from "object-hash";

import { Card } from "../../../../Components/Cards/Card";
import { Placeholder, Text } from "../../../../Components/Typography";
import useResponsive from "../../../../hooks/useResponsive";
import "./AddressFormPickup.scss";
import {
  AddressContext,
  AddressContextProps,
} from "../../../../Contexts/AddressContext";

export const AddressFormPickup = () => {
  const { isDesktopOrLaptop } = useResponsive();
  const { addressPickup }: AddressContextProps =
    useContext<any>(AddressContext);

  const { branches, selectedBranch, setSelectedBranch } = addressPickup;

  const onClickCardAddress = (address: any) => {
    setSelectedBranch(address);
  };

  return (
    <div
      className={
        isDesktopOrLaptop
          ? "address-form-pickup-desktop"
          : "address-form-pickup-mobile"
      }
    >
      {branches.map((item: any) => (
        <Card
          key={hash(item)}
          style={{ minHeight: "200px" }}
          onClick={() => onClickCardAddress(item)}
          active={selectedBranch?.id === item.id}
        >
          <Text bold>{item.name}</Text>

          <div className="margin">
            <Text>{item.address}</Text>
          </div>

          

          <Placeholder bold>Horarios de atención</Placeholder>
          <ul>
            {item.schedule.map((item: any) => (
              <li key={hash(item.schedule)}>{item.schedule}</li>
            ))}
          </ul>

          <div className="margin">
            <a href={item.map} target="_blank">Como llegar</a>
          </div>
        </Card>
      ))}
    </div>
  );
};
